<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :type-mo-full="true">
    <template v-slot>
      <div class="dialog">
        <header class="dialog-header">
          <h2 class="dialog-title">비밀번호를 변경해 주세요</h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <div class="c-round-box">
              <strong class="subject"
                >안전한 서비스 이용을 위해
                <span class="color-primary">새로운 비밀번호로 변경</span>해
                주세요.
              </strong>
              <ul class="c-dot-list type-small">
                <li>
                  새 비밀번호는 기존 비밀번호와 다른 것으로 설정해 주세요.
                </li>
                <li>
                  보안을 위해 띄어쓰기 없는 영문, 숫자, 특수문자 포함 8~15자로
                  설정해주세요.
                </li>
              </ul>
            </div>
            <form class="form-wrap">
              <div class="c-form-field">
                <label
                  class="c-input-label-group type-password"
                  :class="{ 'is-danger': isPasswordNvl }"
                >
                  <input
                    v-if="passwordMaskingYn"
                    type="password"
                    required
                    title="새로운 비밀번호"
                    v-model="form.password"
                    maxlength="15"
                    @keyup="() => (passwordTouched = true)"
                    @blur="() => (passwordTouched = true)"
                  />
                  <input
                    v-if="!passwordMaskingYn"
                    type="text"
                    required
                    title="새로운 비밀번호"
                    v-model="form.password"
                    maxlength="15"
                    @keyup="() => (passwordTouched = true)"
                    @blur="() => (passwordTouched = true)"
                  />
                  <span class="input-label">새로운 비밀번호</span>
                  <span v-show="isPasswordInvalid" class="input-result">
                    사용불가
                  </span>
                  <span v-show="isPasswordEmpty" class="input-helper">
                    비밀번호를 입력해 주세요
                  </span>
                  <span class="input-helper">
                    띄어쓰기 없는 영문, 숫자, 특수문자 (!@#$%^*+=-) 포함 8~15자
                  </span>

                  <button
                    type="button"
                    class="c-btn-icon btn-eye"
                    :class="{ 'is-active': !passwordMaskingYn }"
                    @click.prevent="
                      () => (passwordMaskingYn = !passwordMaskingYn)
                    "
                  >
                    <i class="c-icon icon-eye"></i>
                  </button>
                  <button
                    type="button"
                    class="c-btn-icon btn-small-delete"
                    @click.prevent="() => (form.password = '')"
                  >
                    <span class="c-icon icon-small-x"></span>
                  </button>
                </label>
              </div>
              <div class="c-form-field">
                <label
                  class="c-input-label-group type-password"
                  :class="{ 'is-danger': isPasswordCfmNvl }"
                >
                  <input
                    v-if="passwordCfmMaskingYn"
                    type="password"
                    required
                    title="비밀번호 확인"
                    v-model="form.passwordCfm"
                    maxlength="15"
                    @keyup="() => (passwordCfmTouched = true)"
                    @blur="() => (passwordCfmTouched = true)"
                  />
                  <input
                    v-if="!passwordCfmMaskingYn"
                    type="text"
                    required
                    title="비밀번호 확인"
                    v-model="form.passwordCfm"
                    maxlength="15"
                    @keyup="() => (passwordCfmTouched = true)"
                    @blur="() => (passwordCfmTouched = true)"
                  />
                  <span class="input-label">비밀번호 확인</span>
                  <span v-show="isPasswordCfmNotMatched" class="input-result">
                    불일치
                  </span>
                  <span v-show="isPasswordCfmEmpty" class="input-helper">
                    비밀번호 확인을 입력해 주세요
                  </span>
                  <button
                    type="button"
                    class="c-btn-icon btn-eye"
                    :class="{ 'is-active': !passwordCfmMaskingYn }"
                    @click.prevent="
                      () => (passwordCfmMaskingYn = !passwordCfmMaskingYn)
                    "
                  >
                    <i class="c-icon icon-eye"></i>
                  </button>
                  <button
                    type="button"
                    class="c-btn-icon btn-small-delete"
                    @click.prevent="() => (form.passwordCfm = '')"
                  >
                    <span class="c-icon icon-small-x"></span>
                  </button>
                </label>
              </div>
            </form>
          </div>
        </div>

        <div class="dialog-footer">
          <div v-if="!tmpPwdYn" class="c-checkbox">
            <input
              type="checkbox"
              :id="delayPasswordChangeDateChkId"
              v-model="delayPasswordChangeDateYn"
            />
            <label :for="delayPasswordChangeDateChkId">3개월간 보지 않기</label>
          </div>
          <div class="c-btn-area">
            <button
              type="button"
              class="c-button type-secondary"
              @click.prevent="close"
            >
              <span class="is-pc">나중에 변경하기</span>
              <span class="is-mo">나중에 변경</span>
            </button>
            <button
              type="button"
              class="c-button type-primary"
              :disabled="
                !passwordTouched ||
                !passwordCfmTouched ||
                isPasswordNvl ||
                isPasswordCfmNvl
              "
              @click.prevent="submit"
            >
              <span class="is-pc">비밀번호 변경하기</span>
              <span class="is-mo">비밀번호 변경</span>
            </button>
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>
</template>
<script setup>
import { onMounted, defineEmits, ref, computed, inject } from "vue";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil";
import { api } from "@/plugins/api";
import { v4 as uuidv4 } from "uuid";
import * as store from "@/store";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";

const url = inject("url_prefix");
const applicationStore = store.useApplicationStore();

const emits = defineEmits(["close"]);

const form = ref({
  password: "",
  passwordCfm: "",
});

const passwordTouched = ref(false);
const passwordCfmTouched = ref(false);

const passwordMaskingYn = ref(true);
const passwordCfmMaskingYn = ref(true);
const delayPasswordChangeDateYn = ref(false);
const delayPasswordChangeDateChkId = uuidv4();
onMounted(() => {});
const tmpPwdYn = computed(() => {
  return applicationStore.isShowPasswordChangePop;
});
const isPasswordNvl = computed(() => {
  return isPasswordEmpty.value || isPasswordInvalid.value;
});

const isPasswordEmpty = computed(() => {
  return passwordTouched.value && Utils.isBlank(form.value.password);
});

const isPasswordInvalid = computed(() => {
  return passwordTouched.value && !Utils.isValidPassword(form.value.password);
});

const isPasswordCfmNvl = computed(() => {
  return isPasswordCfmEmpty.value || isPasswordCfmNotMatched.value;
});

const isPasswordCfmEmpty = computed(() => {
  return passwordCfmTouched.value && Utils.isBlank(form.value.passwordCfm);
});

const isPasswordCfmNotMatched = computed(() => {
  return (
    passwordTouched.value && form.value.password !== form.value.passwordCfm
  );
});
const close = async () => {
  if (delayPasswordChangeDateYn.value) {
    await delayPasswordNextChangeDate();
  }

  emits("close");
};

const delayPasswordNextChangeDate = async () => {
  const res = await api.post(
    `${url}/agency/user/password/next-change-date-delay`
  );

  if (res.resultCode !== 200) {
    cmUtil.alert(res.message);
    return;
  }
};
const submit = async () => {
  const payload = {
    password: form.value.password,
  };

  const res = await api.post(`${url}/agency/user/password/change`, payload);

  if (res.resultCode !== 200) {
    cmUtil.alert(res.message);
    return;
  }

  cmUtil.alert("비밀번호가 변경되었습니다.");
  emits("close");
};
</script>
